import React from 'react'
import { Icon } from './Home.elements'

type Props = {
  className?: string
}

export const HomeIcon = ({ className }: Props) => (
  <Icon
    viewBox="0 0 25 25"
    aria-hidden
    focusable={false}
    role="img"
    className={className}
    fill="none"
  >
    <path d="M19.54 13.679a.998.998 0 001.366-1.457l-1.365 1.457zm-7.302-8.215l.682-.728a.998.998 0 00-1.365 0l.683.728zm-8.669 6.758a.998.998 0 101.365 1.457L3.57 12.222zm17.337 0L12.92 4.736l-1.365 1.456 7.986 7.487 1.365-1.457zm-9.351-7.486l-7.986 7.486 1.365 1.457 7.986-7.487-1.365-1.456z" fill="currentColor"/>
    <path d="M5.25 10.954v8.984h1.996v-8.984H5.25zm13.975 8.984v-8.984h-1.996v8.984h1.996z" fill="currentColor"/>
    <path d="M14.234 19.938v-4.991H10.24v4.99" stroke="#4CA9ED" strokeWidth="1.996" strokeLinejoin="round"/>
  </Icon>
)
